import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { SQL_SERVER } from "../../Constants"

function ZdqSqlServerConnector() {
    return <ZdqConnectorSetup vendor={SQL_SERVER}></ZdqConnectorSetup>
}

export default ZdqSqlServerConnector 